import makeApiCall from "../master/axiosIndex";

const checklistApis = {
  createChecklist: async (data: any): Promise<any> => {
    return makeApiCall({
      url: "/checklist/create",
      method: "post",
      data,
    });
  },
  updateChecklist: (data: any) => {
    return makeApiCall({
      url: "/checklist/update",
      method: "put",
      data,
    });
  },

  fetchChecklist: ({
    sortOrder,
    pageSize,
    direction,
    pageDiff,
    paginationId,
    deviation,
    siteIds,
    blockIds,
  }: any): Promise<any> =>
    makeApiCall({
      url: "/checklist/list",
      method: "get",
      params: {
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        deviation,
        siteIds,
        blockIds,
      },
    }),


  fetchChecklistById: (checklistId: any): Promise<any> => {

    return makeApiCall({
      url: `/checklist/id/${checklistId}`,
      method: "get",
    });
  },

  fetchDropdown: (): Promise<any> => {
    return makeApiCall({
      url: "/checklist/dropdown",
      method: "get",
    });
  },
}
export default checklistApis;